import React, { useEffect, useRef } from 'react';
import { View, StyleSheet } from 'react-native';
import Animated, {
    useSharedValue,
    useAnimatedStyle,
    withRepeat,
    withSequence,
    withTiming,
    withDelay,
} from 'react-native-reanimated';

export const AnimatedDots = ({ size = 8, color = '#223F8F', style }) => {
    const dot1Opacity = useSharedValue(0.3);
    const dot2Opacity = useSharedValue(0.3);
    const dot3Opacity = useSharedValue(0.3);

    useEffect(() => {
        // Animate dots in sequence
        dot1Opacity.value = withRepeat(
            withSequence(
                withTiming(1, { duration: 400 }),
                withTiming(0.3, { duration: 400 })
            ),
            -1, // infinite
            false
        );

        dot2Opacity.value = withRepeat(
            withSequence(
                withDelay(200, withTiming(1, { duration: 400 })),
                withTiming(0.3, { duration: 400 })
            ),
            -1,
            false
        );

        dot3Opacity.value = withRepeat(
            withSequence(
                withDelay(400, withTiming(1, { duration: 400 })),
                withTiming(0.3, { duration: 400 })
            ),
            -1,
            false
        );
    }, []);

    const dot1Style = useAnimatedStyle(() => ({
        opacity: dot1Opacity.value,
    }));

    const dot2Style = useAnimatedStyle(() => ({
        opacity: dot2Opacity.value,
    }));

    const dot3Style = useAnimatedStyle(() => ({
        opacity: dot3Opacity.value,
    }));

    return (
        <View style={[styles.container, style]}>
            <Animated.View style={[styles.dot, { width: size, height: size, backgroundColor: color }, dot1Style]} />
            <Animated.View style={[styles.dot, { width: size, height: size, backgroundColor: color, marginHorizontal: size / 2 }, dot2Style]} />
            <Animated.View style={[styles.dot, { width: size, height: size, backgroundColor: color }, dot3Style]} />
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    dot: {
        borderRadius: 100,
    },
});
